import React from 'react'
import UpdateCogenplant from './UpdateCogenplant'
import EditBreadCrumb from './EditBreadCrumb';
function EditCogenplant() {
    return ( 
        <div className = "container-fluid">
        <EditBreadCrumb />
        <UpdateCogenplant />
        </div>
     );
}

export default EditCogenplant;